import React from "react";
import { en, es, ca, texts } from "../lib/constants";

export const Language = ({ userID, language, changeLanguage, isMobile }) => {
  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    changeLanguage(userID, selectedLanguage);
  };

  return (
    <div
      style={{
        fontWeight: "bold",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "2px",
      }}
    >
      <select
        value={language}
        onChange={handleLanguageChange}
        className="language-select"
        style={{ fontSize: isMobile ? "14px" : "18px", cursor: "pointer" }}
      >
        <option value={en} title={texts[en]?.navbarLanguageTitle}>
          {en.toUpperCase()}
        </option>
        <option value={ca} title={texts[ca]?.navbarLanguageTitle}>
          {ca.toUpperCase()}
        </option>
        <option value={es} title={texts[es]?.navbarLanguageTitle}>
          {es.toUpperCase()}
        </option>
      </select>
    </div>
  );
};

